import type { NavItemProps } from "@lifepal/lifepal-design-system/build/components/Navbar";

export const LOGIN_MENU: NavItemProps = {
  "title": "Login",
  "link": "#",
  "iconName": "login",
  "target": "_blank",
  "position": "left",
  "type": "prevent"
};